import { SatelliteConversationMessageType } from '@zg-rentals/ts-satellite-client';
import type { OnSystemMessageCtaClickArgs } from '../../MessageItem';

export function handleSystemMessageCtaClick(
  { messageType, url }: OnSystemMessageCtaClickArgs,
  openRenterDetailsDrawer: () => void,
  leadManagementPath?: string,
): void {
  if (
    messageType === SatelliteConversationMessageType.RENTER_PROFILE_SUBMISSION ||
    (leadManagementPath && url?.includes(leadManagementPath))
  ) {
    openRenterDetailsDrawer();
    return;
  }

  if (url) {
    window.open(url, '_blank');
  }
}
